// extracted by mini-css-extract-plugin
module.exports = {"layout":"WithSider_layout__3E5eT","content":"WithSider_content__1bSZl","locationSidebar":"WithSider_locationSidebar__1eYtf"};